import { useEffect, useState } from "react";
import { Clock3 } from "lucide-react";
import { payments } from "@/api/endpoints/payments";

interface TradeMateOfferBannerProps {
    showForTradeMate: boolean;
}

export default function TradeMateOfferBanner({ showForTradeMate }: TradeMateOfferBannerProps) {
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        let cancelled = false;

        payments
            .getTradeMateOfferSettings()
            .then((response) => {
                if (!cancelled) {
                    setIsActive(Boolean(response?.success && response?.data?.isActive));
                }
            })
            .catch(() => {
                if (!cancelled) setIsActive(false);
            });

        return () => {
            cancelled = true;
        };
    }, []);

    if (!isActive || !showForTradeMate) return null;

    return (
        <div className="mb-4 flex w-full items-center gap-3 rounded-[16px] border border-[#DBD633] px-4 py-3 shadow-[0_0_35px_rgba(219,214,51,0.16)] md:px-6 md:py-4">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full md:h-10 md:w-10">
                <Clock3 className="w-full h-full text-[#DBD633]" aria-hidden="true" />
            </span>
            <div className="min-w-0 text-left">
                <div className="text-[10px] font-bold tracking-[0.14em] text-[#DBD633] md:text-xs md:tracking-[0.18em]">
                    LIMITED TIME OFFER
                </div>
                <div className="mt-0.5 text-sm font-bold leading-tight md:text-xl">
                    <span className="text-[#DBD633]">Buy Get One Free</span>{" "}
                    <span className="text-white">when you pick TradeMate</span>
                </div>
            </div>
        </div>
    );
}
